import React from 'react'

import { AppearingWrapper } from 'Components/Blocks'

import {
  LANDING_CONTENT_PX,
  LANDING_SECTION_GAP,
  LANDING_SECTION_PY,
} from 'Constants/Landing'

import Gallery from './Gallery'
import { Container, Content } from './styles'
import Title from './Title'

function AccessTopCoursesSection() {
  return (
    <Container px={LANDING_CONTENT_PX} py={LANDING_SECTION_PY}>
      <AppearingWrapper centered>
        <Content gap={LANDING_SECTION_GAP}>
          <Title />

          <Gallery />
        </Content>
      </AppearingWrapper>
    </Container>
  )
}

export default AccessTopCoursesSection
